"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageCounter = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useOverviewContext = require("../../hooks/useOverviewContext");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const PageCounter = (param)=>{
    let { pageNumber, totalPageCount, toggleInputMode } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { isOverviewOpen } = (0, _useOverviewContext.useOverviewContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
        "data-testid": getTestId(_constants.COUNTER),
        fontWeight: "bold",
        onClick: toggleInputMode,
        children: isOverviewOpen ? "".concat(translations.allPages, " (").concat(totalPageCount, ")") : "".concat(pageNumber, " / ").concat(totalPageCount)
    });
};
exports.PageCounter = PageCounter;
